export default __webpack_public_path__ + "static/media/Opposites03_17.b0863519.png";